'use strict';

angular.module('amexReconciliationApp')
  .component('transactionListFilterTabGroup', {
    templateUrl: 'scripts/views/components/transaction-list-filter-tab-group.html',
    controller: function (TransactionSearchModel, TransactionCountModel, SearchModel, SiteConfigModel) {
      var self = this;
      self.isAccountingManager = TransactionSearchModel.isAccountingManager;
      self.transactionReceiptsEnabled = SiteConfigModel.transactionReceiptsEnabled;
      self.siteForTransactionReceipts = SiteConfigModel.siteForTransactionReceipts;
      self.isCardManager = TransactionSearchModel.isCardManager;
      self.isCardmember = TransactionSearchModel.isCardMember;
      self.isBcaManager = TransactionSearchModel.isBcaManager;
      self.isOibEnabled = SiteConfigModel.isOibEnabled;
      self.isSearched = SearchModel.isSearched;

      self.displayFilterTab = function() {
        var hasAtLeastOneUnlinkedTransaction = TransactionCountModel.unlinked() > 0;
        return self.displayTpd() && hasAtLeastOneUnlinkedTransaction;
      };

      self.displayTpd = function () {
        return SiteConfigModel.isPo() || SiteConfigModel.isBta();
      };

      self.approvalSettingOnForRole = SiteConfigModel.approvalSettingOnForRole;
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionListFilterTabGroup.js
// module id = 493
// module chunks = 0